"use client";

import { type PropsWithChildren, useEffect, useRef } from "react";

import { pageLegacyEvent } from "@analytics";
import { AppShell } from "./AppShell";

type TrackingEvent = {
  screen?: string;
  userJourney?: string;
  extras?: Record<string, unknown> | undefined;
  disableContainerPadding?: boolean;
  hideRightNav?: boolean;
};

type TrackingEventRef = {
  [K in keyof TrackingEvent]: TrackingEvent[K] | null;
};

type Props = PropsWithChildren & TrackingEvent;

export function Layout({
  children,
  screen,
  extras,
  userJourney,
  disableContainerPadding,
  hideRightNav,
}: Props) {
  const trackRef = useRef<TrackingEventRef>({
    screen: null,
    userJourney: null,
    extras: null,
  });

  useEffect(() => {
    const ref = trackRef.current;
    const isNewPage = screen !== ref.screen || userJourney !== ref.userJourney;

    if (isNewPage && screen && userJourney) {
      pageLegacyEvent({ screen, userJourney, extras });
      trackRef.current = {
        screen,
        userJourney,
      };
    }
  }, [screen, userJourney, extras]);

  return (
    <AppShell
      disableContainerPadding={disableContainerPadding}
      hideRightNav={hideRightNav}
    >
      {children}
    </AppShell>
  );
}
